import { InjectionToken } from '@angular/core';
import { FormDialogService } from '@shared/components/form-dialog/form-dialog.component';
import { FilterService } from '@core/models/form/filter-service';

// tslint:disable:max-line-length
export const SELECT_DIALOG_SERVICE = new InjectionToken<FilterService<any>>('select.dialog.service');
export const FORM_DIALOG_SERVICE = new InjectionToken<FormDialogService>('form.dialog.service');
// tslint:enable:max-line-length
